import React, { useState, useEffect, useContext } from 'react'
import { ThemeContext } from '../../context/ThemeContext';
import { Delete } from 'lucide-react';

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkPincode } from '../../store';

import WebApp from '@twa-dev/sdk'
import { tgShowAlert } from '../../utils/telegramPopup';

/**
 * @brief 핀코드 입력
 * @returns 
 */
const WalletProtection: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const { t } = useTranslation();
	const navigate = useNavigate();
	let dispatch = useDispatch();

	const [pin, setPin] = useState<string[]>([])
	const [confirmPin, setConfirmPin] = useState<string[]>([])
	const [isConfirming, setIsConfirming] = useState(false)
	const [error, setError] = useState(false)
	const [modalVisible, setModalVisible] = useState(false)

	const [shuffledKeys, setShuffledKeys] = useState<string[]>([])

	useEffect(() => {
		setShuffledKeys(shuffleArray(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']))
	}, [])

	useEffect(() => {
		if (pin.length === 6 && !isConfirming) {
			setTimeout(() => {
				setIsConfirming(true)
			}, 200)
		} else if (confirmPin.length === 6 && isConfirming) {
			setTimeout(() => {
				handleConfirm()
			}, 200)
		}
	}, [pin, confirmPin, isConfirming])

	useEffect(() => {
		if (isConfirming) {
			setShuffledKeys(shuffleArray(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']))
		}
	}, [isConfirming])

	// 텔레그램 생체인증 시작
	const TgWebAppStartBioAuth = async () => {
		try {
			// 생체인증 가능하고 접근권한 신청하지 않은 상태
			if (true === WebApp.BiometricManager.isBiometricAvailable) {
				console.log(`WebApp.BiometricManager.isBiometricAvailable TRUE`)
				if (false === WebApp.BiometricManager.isAccessGranted) {
					console.log(`WebApp.BiometricManager.isAccessRequested FALSE`)

					console.log(`WebApp.BiometricManager.requestAccess 권한 요청 시작`)
					const bioParam = { reason: "Telegram BiometricManager requestAccess" }
					WebApp.BiometricManager.requestAccess(bioParam, TgWebAppBioRequestAccessCallBack)
				} else if (true === WebApp.BiometricManager.isAccessGranted) {
					console.log(`WebApp.BiometricManager.isAccessRequested TRUE`)

					console.log(`WebApp.BiometricManager.authenticate 생체인증 요청 시작`)
					const bioParam = { reason: "Telegram BiometricManager authenticate" }
					WebApp.BiometricManager.authenticate(bioParam, TgWebAppBioAuthenticateCallBack)
				}
			} else {
				console.log("WalletRecoveryProtection WebApp.BiometricManager.isBiometricAvailable FALSE")
				// 지문사용 설정 저장
				await localStorage.setItem('fingerprintEnabled', 'false')

				// 다음 페이지로 이동
				setTimeout(() => {
					// @ts-ignore
					navigate(`/SecretPhraseGeneration`, { replace: true, state: { } });
					setError(false)
				}, 1000)
			}
		} catch (error) {
			console.error(`Error Start BioAuth`, error)
		}
	}

	// 텔레그램 생체인식 권한요청 callback()
	const TgWebAppBioRequestAccessCallBack = async (isAccessGranted: boolean) => {
		try {
			if(true === isAccessGranted) {
				// 생체인식 권한 요청 성공

				// 지문인증 사용 권한요청 성공했으므로 지문인증 과정 진행
				const bioParam = { reason: "Telegram BiometricManager authenticate" }
				WebApp.BiometricManager.authenticate(bioParam, TgWebAppBioAuthenticateCallBack)
			} else {
				// 생체인식 권한 요청 실패
				// await tgShowAlert(t('create_wallet_message_16'));
				alert(t('create_wallet_message_16'));
				// navigate(`/CreateWallet`, { replace: true, state: { } });
			}
		} catch (error) {
			console.error("Error TgWebAppBioRequestAccessCallBack Req Bio Access", error)
		}
		return;
	};

	// 텔레그램 생체인식 인증요청 callback()
	const TgWebAppBioAuthenticateCallBack = async (isSuccess: boolean, bioToken: string) => {
		try {
			console.log(`TgWebAppBioAuthenticateCallBack() !!!!!`)
			console.log(`텔레그램 BiometricManager 인증요청 결과 : ${isSuccess}`)

			console.log(`UnlockScreen 텔레그램 SDK API 생체인식 상태`)
			console.log(`WebApp.BiometricManager.isBiometricAvailable : ${WebApp.BiometricManager.isBiometricAvailable}`)
			console.log(`WebApp.BiometricManager.biometricType : ${WebApp.BiometricManager.biometricType}`)
			console.log(`WebApp.BiometricManager.isAccessRequested : ${WebApp.BiometricManager.isAccessRequested}`)
			console.log(`WebApp.BiometricManager.isAccessGranted : ${WebApp.BiometricManager.isAccessGranted}`)
			console.log(`WebApp.BiometricManager.isBiometricTokenSaved : ${WebApp.BiometricManager.isBiometricTokenSaved}`)

			if (true === isSuccess) {
				// 인증성공 pincode 저장
				if (confirmPin.join('') === pin.join('')) {
					const pinCode = pin.join('')
					WebApp.BiometricManager.updateBiometricToken(pinCode, TgWebAppUpdateBioTokenCallBack);
				}
			} else {
				setConfirmPin([])
				setIsConfirming(false)

				// await tgShowAlert(t('create_wallet_message_16'));
				alert(t('create_wallet_message_16'));
			}

		} catch (error) {
			console.log(`Error Tg Bio Auth`, error)
		}
	}

	// bioToken update
	const TgWebAppUpdateBioTokenCallBack = async (isSuccess: boolean) => {
		// bioToken 업데이트 결과 확인
		if (true == isSuccess) {
			// 지문사용 설정 저장
			await localStorage.setItem('fingerprintEnabled', 'true')

			// 다음 페이지로 이동
			setTimeout(() => {
				// @ts-ignore
				navigate(`/SecretPhraseGeneration`, { replace: true, state: { } });
				
				setError(false)
			}, 500)
		} else {
			await localStorage.setItem('fingerprintEnabled', 'false');
			alert(t('create_wallet_message_16'));

			// 처음 페이지로 이동
			setTimeout(() => {
				// @ts-ignore
				navigate(`/CreateWallet`, { replace: true, state: { } });
				setError(false)
			}, 500)
		}
	}

	const handleKeyPress = (key: string) => {
		if (key === 'backspace') {
			if (isConfirming) {
				setConfirmPin(prevPin => prevPin.slice(0, -1))
			} else {
				setPin(prevPin => prevPin.slice(0, -1))
			}
		} else {
			if (isConfirming) {
				if (confirmPin.length < 6) {
					setConfirmPin(prevPin => [...prevPin, key])
				}
			} else {
				if (pin.length < 6) {
					setPin(prevPin => [...prevPin, key])
				}
			}
		}
	}

	const handleConfirm = async () => {
		// setModalVisible(true)

		if (confirmPin.join('') === pin.join('')) {
			// redux 에 pincode 임시 저장
			const pinCode = pin.join('')

			// 입력된 핀코드 저장
			dispatch(checkPincode(pinCode))

			// 셍체인증 초기화 상태, 생체인증 사용 가능 상태 확인
			if (true === WebApp.BiometricManager.isInited && WebApp.BiometricManager.isBiometricAvailable) {
				// 지문인식 사용가능
				setModalVisible(true)
			} else {
				// 지문인식 사용불가
				setTimeout(() => {
					// @ts-ignore
					navigate(`/SecretPhraseGeneration`, { replace: true, state: { } });
					setError(false)
				}, 500)
			}

			// // @ts-ignore
			// navigate(`/SecretPhraseGeneration`)
			// setError(false)
		} else {
			setError(true)
			// Vibration.vibrate()
			setTimeout(() => {
				setConfirmPin([])
				setError(false)
			}, 1000)
		}
	}

	const handleModalClose = async (useFingerprint: boolean) => {
		setModalVisible(false)
		if (true == useFingerprint) {
			// 지문인식 초기화 시작
			TgWebAppStartBioAuth();
		} else {
			// 지문인식 사용 안함
			await localStorage.setItem('fingerprintEnabled', 'false')

			// @ts-ignore
			navigate('/SecretPhraseGeneration')
		}
	}

	const handleFingerprintAuthSuccess = async () => {
		try {
			await localStorage.setItem('fingerprintEnabled', 'true')
		} catch (error) {
			console.error('Failed to save fingerprint setting to storage', error)
		}

		navigate('/SecretPhraseGeneration')
	}

	const handleFingerprintAuthFailure = async () => {
		await localStorage.setItem('fingerprintEnabled', 'false')

		navigate('/SecretPhraseGeneration')
	}

	const shuffleArray = (array: string[]) => {
		let currentIndex = array.length,
			randomIndex

		while (currentIndex !== 0) {
			randomIndex = Math.floor(Math.random() * currentIndex)
			currentIndex--
				;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
		}

		return array
	}

	const styles = {
		container: {
			padding: "60px 0px 24px",
		} as React.CSSProperties,
		header: {
			height: "135px"
		} as React.CSSProperties,
		title1: {
			fontSize: 24,
			textAlign: 'center',
		} as React.CSSProperties,
		title2: {
			fontSize: 24,
			textAlign: 'center',
			marginBottom: 10
		} as React.CSSProperties,
		subtitle1: {
			fontSize: 14,
			textAlign: 'center'
		} as React.CSSProperties,
		pinContainer: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			gap: '10px',
		} as React.CSSProperties,
		pinDot: {
			width: 12,
			height: 12,
			borderRadius: 8,
			margin: 8
		} as React.CSSProperties,
		pinDotError: {
			backgroundColor: theme.status_destrective,
		} as React.CSSProperties,
		basicText: {
			fontSize: 14,
			height: "40px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			marginTop: "15px",
			textAlign: 'center',
			lineHeight: "22px"
		} as React.CSSProperties,
		errorText: {
			fontSize: 14,
			height: "40px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			marginTop: "15px"
		} as React.CSSProperties,
		keypadContainer: {
			width: '100%',
		} as React.CSSProperties,
		keypadRow: {
			display: "flex",
			justifyContent: 'space-around',
			width: '100%',
			marginBottom: "5px"
		} as React.CSSProperties,
		key: {
			display: "flex",
			width: 70,
			height: 70,
			justifyContent: 'center',
			alignItems: 'center',
			cursor: "pointer"
		} as React.CSSProperties,
		keyPlaceholder: {
			width: 70,
			height: 70,
		} as React.CSSProperties,
		keyText: {
			fontSize: 24,
		} as React.CSSProperties,
		modalOverlay: {
			width: '100%',
			height: '100%',
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: theme.background_alternative,
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: "translate(-50%, -50%)"
		} as React.CSSProperties,
		modalContent: {
			width: '75%',
			backgroundColor: theme.static_white,
			borderRadius: 28,
			padding: 20,
			alignItems: 'center',
			textAlign: 'center'
		} as React.CSSProperties,
		modalTitle: {
			fontSize: 18,
			marginBottom: 5,
		} as React.CSSProperties,
		modalSubtitle: {
			fontSize: 16,
			marginBottom: 10,
		} as React.CSSProperties,
		modalDescription1: {
			fontSize: 14,
			textAlign: 'center'
		} as React.CSSProperties,
		modalDescription2: {
			fontSize: 14,
			marginBottom: 20,
			textAlign: 'center'
		} as React.CSSProperties,
		modalButtons: {
			display: "flex",
			justifyContent: 'space-between',
			width: '100%'
		} as React.CSSProperties,
		modalButton: {
			padding: 10,
			margin: 5,
			backgroundColor: theme.static_white,
			height: 56,
			borderRadius: 10,
			justifyContent: "center",
			width: '50%'
		} as React.CSSProperties,
		modalButtonText: {
			fontSize: 14,
			color: theme.static_white
		} as React.CSSProperties,
		modalButtonPrimaryText: {
			color: theme.static_white
		} as React.CSSProperties,
	}

	const renderKey = (key: string, index: number) => (
		<div key={index}>
			<div
				onClick={() => { handleKeyPress(key) }}
				style={{
					// backgroundColor: theme.keyPadBackgroundColor,
					borderRadius: '50%',
				}}
			>
				<div style={styles.key}>
					<CustomText weight='medium' style={{ ...styles.keyText, color: theme.label_strong }}>
						{key}
					</CustomText>
				</div >
			</div >
		</div >
	)


	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div style={styles.header}>
				<CustomText weight="medium" style={{ ...styles.title1, color: theme.label_strong }}>
					{isConfirming ? t('create_wallet_message_03') : t('create_wallet_message_01')}
				</CustomText>
				<CustomText weight="medium" style={{ ...styles.title2, color: theme.label_strong }}>
					{isConfirming ? t('create_wallet_message_04') : t('create_wallet_message_02')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle1, color: theme.label_alternative }}>
					{t('create_wallet_message_05')}
				</CustomText>
				<CustomText style={{ ...styles.subtitle1, color: theme.label_alternative }}>
					{t('create_wallet_message_06')}
				</CustomText>
			</div>
			<div>
				<div style={styles.pinContainer}>
					{Array.from({ length: 6 }).map((_, index) => {
						const baseStyle: React.CSSProperties = {
							...styles.pinDot,
							// backgroundColor: theme.label_strong,
						};

						const activeStyle: React.CSSProperties =
							(isConfirming ? confirmPin.length > index : pin.length > index)
								? { backgroundColor: theme.primary_normal }
								: {};

						const errorStyle: React.CSSProperties =
							error && isConfirming && confirmPin.length > index ? styles.pinDotError : {};

						return (
							<div style={{ borderBottom: `1px solid ${error?theme.status_destrective:((false === isConfirming && pin.length > index) || (true === isConfirming && confirmPin.length > index) ?theme.primary_normal:theme.line_alternative) }` }}>
								<div key={index} style={{ ...baseStyle, ...activeStyle, ...errorStyle }} />
							</div>
						);
					})}
				</div>
				{
					error
						?
						<CustomText style={{ ...styles.errorText, color: theme.status_destrective }}>
							{t('create_wallet_message_07')}
						</CustomText>
						:
						<CustomText style={{ ...styles.basicText, color: theme.label_normal }}>
							{t('create_wallet_message_14')}<br />
							{/* {t('create_wallet_message_15')} */}
						</CustomText>
				}
			</div>
			<div style={styles.keypadContainer}>
				{Array.from({ length: 3 }).map((_, rowIndex) => (
					<div key={rowIndex} style={styles.keypadRow}>
						{shuffledKeys.slice(rowIndex * 3, rowIndex * 3 + 3).map((key, index) => renderKey(key, index))}
					</div>
				))}
				<div style={styles.keypadRow}>
					<div style={styles.keyPlaceholder}></div>
					{renderKey(shuffledKeys[9], 9)}
					<div key="backspace">
						<div
							onClick={() => { handleKeyPress('backspace') }}
							style={styles.key}
						>
							<Delete size={24} color={theme.label_strong} />
						</div>
					</div>
				</div>
			</div>
			{
				modalVisible && (
					<div style={styles.modalOverlay}>
						<div style={styles.modalContent}>
							<CustomText weight="bold" style={{ ...styles.modalTitle, color: theme.static_black }}>
								{t('create_wallet_message_08')}
							</CustomText>
							<CustomText weight="bold" style={{ ...styles.modalSubtitle, color: theme.static_black }}>
								{t('create_wallet_message_09')}
							</CustomText>
							<CustomText style={{ ...styles.modalDescription1, color: theme.label_alternative }}>
								{t('create_wallet_message_10')}
							</CustomText>
							<CustomText style={{ ...styles.modalDescription2, color: theme.label_alternative }}>
								{t('create_wallet_message_11')}
							</CustomText>
							<CustomText style={{ ...styles.modalDescription1, color: theme.status_destrective }}>
								{t('create_wallet_message_17')}
							</CustomText>
							<CustomText style={{ ...styles.modalDescription2, color: theme.status_destrective }}>
								{t('create_wallet_message_18')}
							</CustomText>
							<div style={styles.modalButtons}>
								<CustomButton
									containerStyle={{ ...styles.modalButton, backgroundColor: theme.primary_alternative }}
									textStyle={{ ...styles.modalButtonText, color: theme.static_black }}
									onPress={() => handleModalClose(false)}
									text={t('create_wallet_message_12')}
									weight="medium"
									withBackground={true}
									backgroundColor={theme.primary_alternative}
								/>
								<CustomButton
									containerStyle={{ ...styles.modalButton, backgroundColor: theme.primary_normal }}
									textStyle={{ ...styles.modalButtonText, ...styles.modalButtonPrimaryText }}
									onPress={() => handleModalClose(true)}
									text={t('create_wallet_message_13')}
									weight="medium"
									withBackground={true}
									backgroundColor={theme.primary_normal}
								/>
							</div>
						</div>
					</div>
				)
			}
		</div>
	)
}

export default WalletProtection
